import React from 'react';
import { PageHeader } from '@/components/common/PageHeader';
import { Card, CardContent } from '@/components/ui/card';
import { directorInfo } from '@/data/facultyData';
import { Quote, Target, TrendingUp } from 'lucide-react';
import { motion } from 'framer-motion';

const DirectorPage = () => {
  return (
    <div>
      <PageHeader
        title="Message from Director"
        subtitle="Vision and leadership guiding Mantra Prayas Institute"
        breadcrumbs={[
          { label: 'Home', path: '/' },
          { label: 'Director' }
        ]}
      />

      <section className="section-padding bg-background">
        <div className="container-custom max-w-6xl">
          {/* Director Profile */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="grid lg:grid-cols-5 gap-12 mb-16"
          >
            <div className="lg:col-span-2">
              <Card className="overflow-hidden">
                <img
                  src={directorInfo.image}
                  alt={directorInfo.name}
                  className="w-full h-auto object-cover"
                />
              </Card>
              <Card className="mt-6">
                <CardContent className="p-6">
                  <h3 className="text-2xl font-heading font-bold text-foreground mb-2">
                    {directorInfo.name}
                  </h3>
                  <p className="text-secondary font-semibold mb-4">{directorInfo.designation}</p>
                  <div className="space-y-2 text-sm text-muted-foreground">
                    <p><strong className="text-foreground">Qualification:</strong> {directorInfo.qualification}</p>
                    <p><strong className="text-foreground">Experience:</strong> {directorInfo.experience}</p>
                  </div>
                </CardContent>
              </Card>
            </div>

            <div className="lg:col-span-3 space-y-8">
              <Card className="border-2">
                <CardContent className="p-8">
                  <div className="flex items-start space-x-4 mb-6">
                    <Quote className="h-12 w-12 text-primary flex-shrink-0" />
                    <div>
                      <h3 className="text-2xl font-heading font-bold text-foreground mb-2">
                        Director's Message
                      </h3>
                      <p className="text-sm text-muted-foreground">A word from our founder</p>
                    </div>
                  </div>
                  <div className="prose prose-lg max-w-none">
                    {directorInfo.message.split('\n\n').map((para, idx) => (
                      <p key={idx} className="text-foreground leading-relaxed mb-4">
                        {para}
                      </p>
                    ))}
                  </div>
                </CardContent>
              </Card>

              <div className="grid md:grid-cols-2 gap-6">
                <Card className="bg-gradient-to-br from-primary/10 to-transparent border-primary/20">
                  <CardContent className="p-6">
                    <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                      <Target className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="font-heading font-bold text-foreground mb-2">Our Vision</h4>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {directorInfo.vision}
                    </p>
                  </CardContent>
                </Card>

                <Card className="bg-gradient-to-br from-secondary/10 to-transparent border-secondary/20">
                  <CardContent className="p-6">
                    <div className="h-12 w-12 rounded-full bg-secondary/10 flex items-center justify-center mb-4">
                      <TrendingUp className="h-6 w-6 text-secondary" />
                    </div>
                    <h4 className="font-heading font-bold text-foreground mb-2">Our Mission</h4>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {directorInfo.mission}
                    </p>
                  </CardContent>
                </Card>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default DirectorPage;
